import { Component, OnInit } from '@angular/core';
import { UserService, GeneralService } from '../../../services/_index';
import { MatDialog, MatDialogRef } from '@angular/material';
import { UserModel,ChangePasswordRequest } from '../../../_models/_index';
import { Router } from '@angular/router';
import { LoginErrorEnum } from '../../../_enums/login-error.enum';
@Component({
    selector: 'app-change-password-dialog',
    templateUrl: './change-password-dialog.component.html',
    styleUrls: ['./change-password-dialog.component.css']
})
export class ChangePasswordDialogComponent implements OnInit {


    user: UserModel;
    changePasswordRequest: ChangePasswordRequest;
    secondPassword: string;
    hide1: boolean;
    hide2: boolean;

    constructor(private router: Router,
        private generalService: GeneralService,
        private userService: UserService,
        private dialog: MatDialog,
        public dialogRef: MatDialogRef<ChangePasswordDialogComponent>) {
        this.changePasswordRequest = new ChangePasswordRequest();

    }

    ngOnInit() {
        this.hide1 = true;
        this.hide2 = true;
    }

  

    save() {
        if (!this.validatePassword()) {
            return;
        }
        if (this.changePasswordRequest.password == this.secondPassword) {
            this.changePasswordRequest.userID = this.user.id;
            this.userService.changePassword(this.changePasswordRequest).then(res => {
                if (res) {
                    this.user = res;
                    this.dialogRef.close(this.user);
                    
                }
            });
        }
        else {
            this.generalService.showErrorDialog("סיסמאות לא זהות");
        }
    }

    private validatePassword() {
        var regex = /(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&].{7,}/g;
        let res = regex.test(this.changePasswordRequest.password);
        if (!res) {
            this.generalService.showErrorDialog("הזן סיסמא בעלת 8 תווים לפחות,אות גדולה,אות קטנה,ספרה ותו מיוחד(@$!*?&)");
            return false;
        }
        return true;
    }

}



// WEBPACK FOOTER //
// ./src/app/components/login/change-password-dialog/change-password-dialog.component.ts